'use es6';

import { createTracker } from 'usage-tracker';
import { getParsedTrackingParams } from 'ecosystem-marketplace-core/utils/trackingParams';
import events from '../../events.yaml';
let tracker;
export const getUsageTracker = () => tracker;
export const setUsageTracker = _tracker => {
  tracker = _tracker;
};

const getSessionUrlParams = () => {
  const trackingParams = getParsedTrackingParams();
  return Object.keys(trackingParams).reduce((final, key) => {
    const value = trackingParams[key];
    final.push(`${key}=${value}`);
    return final;
  }, []);
};

export const getUsageTrackerConfig = ({
  embed = false,
  inAppOrPublic = 'in-app'
} = {}) => ({
  events,
  properties: {
    namespace: 'marketplace',
    embed,
    inAppOrPublic,
    sessionUrlParams: getSessionUrlParams()
  },
  lastKnownEventProperties: ['screen']
});
export const createUsageTracker = properties => {
  setUsageTracker(createTracker(getUsageTrackerConfig(properties)));
  return tracker;
};